export default __webpack_public_path__ + "static/media/logout.134cab9e.svg";